type CountryFlags = {
  isCh: boolean;
  isFr: boolean;
  isEs: boolean;
  isIt: boolean;
  isPl: boolean;
  isPt: boolean;
};

type CountryWhereClause<T> = {
  chWhere: T | undefined;
  frWhere: T | undefined;
  esWhere: T | undefined;
  itWhere: T | undefined;
  plWhere: T | undefined;
  ptWhere: T | undefined;
};

export const buildCountryFlags = (countryCode: string): CountryFlags => ({
  isCh: countryCode === 'CH',
  isFr: countryCode === 'FR',
  isEs: countryCode === 'ES',
  isIt: countryCode === 'IT',
  isPl: countryCode === 'PL',
  isPt: countryCode === 'PT',
});

export const buildCountryWhereClause = <T>(
  countryCode: string,
  whereClause: T | undefined,
): CountryWhereClause<T> & CountryFlags => ({
  ...buildCountryFlags(countryCode),
  chWhere: countryCode === 'CH' ? whereClause : undefined,
  frWhere: countryCode === 'FR' ? whereClause : undefined,
  esWhere: countryCode === 'ES' ? whereClause : undefined,
  itWhere: countryCode === 'IT' ? whereClause : undefined,
  plWhere: countryCode === 'PL' ? whereClause : undefined,
  ptWhere: countryCode === 'PT' ? whereClause : undefined,
});

export const buildRadiusWhereClause = <T>(
  countryCode: string,
  listingWhereClause: T | undefined,
): CountryWhereClause<{ listing: T } | undefined> & CountryFlags => {
  const wrappedClause = listingWhereClause
    ? { listing: listingWhereClause }
    : undefined;

  return {
    ...buildCountryFlags(countryCode),
    chWhere: countryCode === 'CH' ? wrappedClause : undefined,
    frWhere: countryCode === 'FR' ? wrappedClause : undefined,
    esWhere: countryCode === 'ES' ? wrappedClause : undefined,
    itWhere: countryCode === 'IT' ? wrappedClause : undefined,
    plWhere: countryCode === 'PL' ? wrappedClause : undefined,
    ptWhere: countryCode === 'PT' ? wrappedClause : undefined,
  };
};
